module.exports = __webpack_public_path__ + "media/video210.01def961.mp4";